/*
 * House of Daisy — the cookie banner (board E4). Reads and writes her choice
 * through Shopify's Customer Privacy API (consent-tracking-api), so every
 * Shopify surface — pixels, the Google & YouTube channel, apps — honours it.
 * Nothing here stores anything of its own.
 *
 * Shown to a visitor who has not chosen yet (or, with the theme setting,
 * only where Shopify's privacy settings ask for a banner). The footer line
 * says what she allowed and reopens the choices.
 */
(function () {
  var KINDS = ['analytics', 'marketing', 'preferences'];

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function withApi(done) {
    var S = window.Shopify;
    if (!S) return;
    if (S.customerPrivacy) return done(S.customerPrivacy);
    if (typeof S.loadFeatures !== 'function') return;
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && window.Shopify.customerPrivacy) done(window.Shopify.customerPrivacy);
    });
  }

  function init() {
    // The banner itself (a section): the try-on page has its own consent checkbox, which the plain attribute also matched.
    var banner = document.querySelector('section[data-hod-consent]');
    var footer = document.querySelector('[data-hod-consent-footer]');
    var copyNode = document.querySelector('[data-hod-consent-copy]');
    if (!banner || !copyNode) return;
    var c = JSON.parse(copyNode.textContent);
    Object.keys(c).forEach(function (k) {
      c[k] = decode(c[k]);
    });
    var sheet = banner.querySelector('[data-hod-consent-sheet]');
    var choose = banner.querySelector('[data-hod-consent-choose]');
    var save = banner.querySelector('[data-hod-consent-save]');
    var switches = {};
    KINDS.forEach(function (k) {
      switches[k] = banner.querySelector('[data-hod-consent-kind="' + k + '"]');
    });

    withApi(function (cp) {
      // Her choice is also kept on her device (owner, 2026-10-11: on an iPhone the notice stayed open, faded, after a
      // tap — Shopify had not confirmed the choice in time). The notice closes at once on her tap; Shopify is told,
      // and told again on her next page if it has not recorded it.
      var LOCAL = 'hodConsentChoice';
      function local() {
        try {
          var v = JSON.parse(localStorage.getItem(LOCAL) || 'null');
          return v && typeof v === 'object' && v.values ? v.values : null;
        } catch (e) {
          return null;
        }
      }
      function remember(values) {
        try {
          localStorage.setItem(LOCAL, JSON.stringify({ values: values, at: Date.now() }));
        } catch (e) {
          /* private browsing: Shopify's own record is all there is */
        }
      }
      var shopifyChosen = function () {
        var now = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
        return KINDS.some(function (k) {
          return now[k] === 'yes' || now[k] === 'no';
        });
      };
      // What she chose: her latest tap on this device, else Shopify's record.
      var current = function () {
        var mine = local();
        if (!mine) return (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
        var out = {};
        KINDS.forEach(function (k) {
          out[k] = mine[k] ? 'yes' : 'no';
        });
        return out;
      };
      var chosen = function () {
        return shopifyChosen() || !!local();
      };
      // Shopify does not (yet) hold her latest tap: tell it again, quietly.
      var differs = function () {
        var mine = local();
        if (!mine) return false;
        if (!shopifyChosen()) return true;
        var theirs = cp.currentVisitorConsent();
        return KINDS.some(function (k) {
          return (theirs[k] === 'yes') !== !!mine[k];
        });
      };
      if (differs()) {
        try {
          cp.setTrackingConsent(local(), function () {});
        } catch (e) {
          /* tried again on the next page */
        }
      }

      function describe() {
        if (!footer) return;
        var now = current();
        if (!chosen()) {
          footer.hidden = true;
          return;
        }
        var yes = KINDS.filter(function (k) {
          return now[k] === 'yes';
        }).map(function (k) {
          return c[k];
        });
        var what = yes.length ? (yes.length === 1 ? yes[0] : yes.slice(0, -1).join(', ') + ' ' + c.and + ' ' + yes[yes.length - 1]) : '';
        footer.querySelector('[data-hod-consent-now]').textContent = yes.length ? c.allowedSome.replace('[what]', what) : c.allowedNone;
        footer.hidden = false;
      }

      function open(withSheet) {
        var now = current();
        KINDS.forEach(function (k) {
          if (switches[k]) switches[k].checked = now[k] === 'yes';
        });
        sheet.hidden = !withSheet;
        save.hidden = !withSheet;
        choose.hidden = !!withSheet;
        choose.setAttribute('aria-expanded', withSheet ? 'true' : 'false');
        banner.hidden = false;
        // Floating chat buttons (the WhatsApp bubble) sit above everything and covered these buttons on phones
        // (owner, 2026-10-01): they step aside while she chooses.
        document.documentElement.classList.add('hod-consent-open');
      }

      function close() {
        banner.hidden = true;
        document.documentElement.classList.remove('hod-consent-open');
      }

      function set(values) {
        // Her tap is her answer: kept on her device and the notice closes at once, whatever the network does.
        remember(values);
        close();
        describe();
        try {
          cp.setTrackingConsent(values, function () {
            describe();
          });
        } catch (e) {
          /* Shopify is told again on her next page */
        }
      }

      banner.querySelector('[data-hod-consent-none]').addEventListener('click', function () {
        // sale_of_data too: a US visitor's opt-out of data sale was never recorded (a review, 2026-09-29).
        set({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
      });
      banner.querySelector('[data-hod-consent-all]').addEventListener('click', function () {
        set({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
      });
      choose.addEventListener('click', function () {
        open(true);
        if (switches.analytics) switches.analytics.focus();
      });
      save.addEventListener('click', function () {
        var values = {};
        KINDS.forEach(function (k) {
          values[k] = !!(switches[k] && switches[k].checked);
        });
        // Sharing her data for advertising goes with the marketing switch.
        values.sale_of_data = values.marketing;
        set(values);
      });
      if (footer) {
        footer.querySelector('[data-hod-consent-change]').addEventListener('click', function () {
          open(true);
          banner.scrollIntoView({ block: 'nearest' });
        });
      }

      // Shopify adds a "Cookie preferences" link to the footer policy list (#shopifyReshowConsentBanner). It reopens
      // Shopify's own banner, which hod-base.css hides, so the link did nothing: it opens this notice instead.
      document.addEventListener(
        'click',
        function (event) {
          var link = event.target.closest && event.target.closest('a[href$="#shopifyReshowConsentBanner"]');
          if (!link) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          open(true);
          banner.scrollIntoView({ block: 'nearest' });
          if (switches.analytics) switches.analytics.focus();
        },
        true
      );

      describe();
      var ask = banner.dataset.who === 'regions' ? !!(cp.shouldShowBanner && cp.shouldShowBanner()) : true;
      if (ask && !chosen()) open(false);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
